import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { apiUrl } from "../../config";
import { fetchAllUser } from "../../service/UserService";
import { useToast } from "../toast/ToastProvider";
import RichTextEditor from "./RichTextEditor";

const initialState = {
  id: 0,
  userId: "",
  title: "",
  bannerImageUrl: "",
  content: "",
};

const PagesForm = ({ onSave, initialData, readOnly,loading,setLoading }) => {
  const [pagesForm, setPagesForm] = useState(initialState);
  const [previewImage, setPreviewImage] = useState(null);
  const [users, setUsers] = useState([]);

  const toast = useToast();


  useEffect(() => {
    return () => {
      if (previewImage && previewImage.startsWith("blob")) {
        URL.revokeObjectURL(previewImage);
      }
    };
  }, [previewImage]);

  // Fetch user userDropdown
  useEffect(() => {
    const fetchAllUsers = async () => {
      try {
        const res = await fetchAllUser();

        setUsers(res)

      } catch (error) {
        toast("Error fetching User data", "ERROR");

      }
    }
    fetchAllUsers();
  }, [])

  useEffect(() => {
    if (initialData) {
      setPagesForm(initialData);
      if (initialData.bannerImageUrl) {
        if (typeof initialData.bannerImageUrl === "string") {
          // Existing image URL
          setPreviewImage(apiUrl + "/" + initialData.bannerImageUrl);
        } else if (initialData.bannerImageUrl instanceof File) {
          // New file selected
          const url = URL.createObjectURL(initialData.bannerImageUrl);
          setPreviewImage(url);
        }
      } else {
        setPreviewImage(null);
      }
    } else {
      setPagesForm(initialState);
      setPreviewImage(null);
    }
  }, [initialData]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPagesForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPagesForm((prev) => ({ ...prev, bannerImageUrl: file }));
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true)
    onSave(pagesForm);
    setTimeout(() => {
    setLoading(false);
  }, 2000);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col md={8}>
          <Form.Group controlId="userId">
            <Form.Label>
              User <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Select
              name="userId"
              value={pagesForm.userId}
              onChange={handleChange}
              disabled={readOnly}
              required
            >
              {users?.map((cat) => (
                <option value={cat.userId} key={cat.userId}>
                  {cat.username}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={12}>
          <Form.Group controlId="title">
            <Form.Label>
              Title <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={pagesForm.title}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={12}>
          <Form.Group controlId="content">
            <Form.Label>
              content <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <RichTextEditor
              key={pagesForm.id}
              initialValue={pagesForm.content || ""}
              isEditable={!readOnly}
              onChange={(html) =>
                setPagesForm((prev) => ({ ...prev, content: html }))
              }
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={12}>
          <Form.Group controlId="image">
            <Form.Label>Image</Form.Label>
            <Form.Control
              type="file"
              onChange={handleFileChange}
              disabled={readOnly}
            />
            {previewImage && (
              <div className="mt-2">
                <img
                  src={previewImage}
                  alt="Preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    marginTop: "10px",
                  }}
                />
              </div>
            )}
          </Form.Group>
        </Col>
      </Row>

      {!readOnly && (
        <Row>
          <Col md={12}>
            <div className="form-buttons">
              <Button
                type="submit"
                className="btn btn-primary me-2"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Saving...
                  </>
                ) : (
                  "Save"
                )}
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  setPagesForm(initialState);
                  setPreviewImage(null);
                }}
              >
                Clear
              </Button>
            </div>
          </Col>
        </Row>
      )}
    </Form>
  );
};

export default PagesForm;
